module.exports = __webpack_public_path__ + "img/tactical_bomber.3cd82587.jpg";